<template>
  <v-container class="pa-0" @keydown.esc="closeWindow">
    <!-- nagłówek karty  -->
    <v-card class="mb-2" @keydown.esc="closeWindow" key="Header">
      <v-card-title class="py-0 px-0">
        <v-card class="m0" color="primary" dark style="width: 100%">
          <v-card-title class="pt-0 pb-2 pl-2 pr-1">
            <span class="title font-weight-bold"
              >{{ $t("Downloads.Topic") }}
            </span>
            <v-spacer></v-spacer>
            <v-icon color="blue darken-1" @click="closeWindow()"
              >mdi-close
            </v-icon>
          </v-card-title>
          <v-card-subtitle class="pb-0 pb-sm-2 pl-2">
            {{ $t("Downloads.TopicDescription") }}
          </v-card-subtitle>
        </v-card>
      </v-card-title>
    </v-card>
    <!-- Zawartość karty -->
    <v-card  class="px-4 pt-0 pb-2 grey lighten-5 d-flex justify-end" key="Downloads">
     
      <v-row>
        <v-col cols="1">
          <v-card
            color="#385F73"
            dark
          >
            <v-card-title class="text-h5">
              TeamViewer
            </v-card-title>
            <v-card-actions>
              <v-btn @click.prevent="onClick()" text>
                Pobierz
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
axios.defaults.withCredentials = true
axios.defaults.headers.get['header-name'] = 'value'
axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

export default {
  components: {
  },
  data() {
    

    return {
       url:'https://termoprofil.com.pl/download/5.png',

        item: [
        {
          url: "https://termoprofil.com.pl/download/5.png",
          label : "Pobierz"
        }
          
      ],
    };
  },
  methods: {
    closeWindow() {
      this.$router.push("/");
    },
    forceFileDownload(response){
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
     // link.setAttribute('download', 'file.png') //or any other extension
      document.body.appendChild(link)
      link.click()
    },
    downloadWithVueResource_old(fileName) {
      this.$http({
        method: 'get',
        url: fileName,
        responseType: 'arraybuffer'
      })
      .then(response => {
        this.forceFileDownload(response)  
      })
      .catch()
      
    },
   
    downloadItem (url) {
        axios.defaults.withCredentials = true;
        //alert(url);
        axios.get(url, { responseType: 'blob' })
          .then(response => {
            const blob = new Blob([response.data])
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.click()
            URL.revokeObjectURL(link.href)
          }).catch()
      },
       
       onClick() {
              alert("12");
              
              axios({
                    url: 'https://termoprofil.eu/vue/5.png',
                    method: 'GET',
                    responseType: 'blob',
                    
                    
                }).then((response) => {
                     var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                     var fileLink = document.createElement('a');
   
                     fileLink.href = fileURL;
                     fileLink.setAttribute('download', 'file.png');
                     document.body.appendChild(fileLink);
   
                     fileLink.click();
                });
          },
          async download(){

           this.downloadFile("https://termoprofil.com.pl/download/5.png");
          },
    downloadFile(context, url) {
      return new Promise((resolve, reject) => {
        const method = "GET";
        axios
          .request({
            url: url,
            method,
            responseType: "blob"
          })
          .then(response => {
            let fileURL = window.URL.createObjectURL(
              new Blob([response.data]),
              {
                type: response.headers["content-type"]
              }
            );
            let fileLink = document.createElement("a");
            fileLink.href = fileURL;
            let fileName = response.headers["content-disposition"].split(
              "filename="
            )[1];
         
            fileLink.setAttribute("download", fileName);
            document.body.appendChild(fileLink);

            fileLink.click();
            fileLink.remove();
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    

  },

  beforemount() {},
  created() {},
  destroyed() {}
};
</script>
